import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()({
  midnightButton: {
    padding: 0,
  },
})
